import { Popover } from "antd";
import supportIcon from "assets/icons/support.svg";

function Support() {
  const content = (
    <div>
      <p className="support__item">
        This email’s subject line will be{" "}
        <span className="support__item-hightlight">
          “Kovena Access Code”
        </span>
      </p>
      <p className="support__item">
        It can take up to a few minutes before you receive the email. Please ensure you have checked
        your spam/junk folder and other email folders for the verification code before attempting to
        resend the code.{" "}
      </p>
      <p className="support__item">
        If you are not receiving a code at all, please contact{" "}
        <a className="support__item-mail" href="mailto:support@kovena.com.">
          support@kovena.com.
        </a>
      </p>
    </div>
  );
  return (
    <Popover overlayClassName="support__overlay" placement="rightTop" content={content}>
      <span className="support">
        <img src={supportIcon} alt="" />
      </span>
    </Popover>
  );
}

export default Support;
